module.exports = __webpack_public_path__ + "img/shopping_application_202604-1.35b2edb1.jpg";